import { useTranslation } from "react-i18next";
import { IntersectionFadeIn } from "@/core/shared/v2/ui/intersection-fade-in";
import { UserIdForm } from "../../components/user-id-form";
import { useFlowPath } from "../../hooks/use-flow-path";
import { useValidateUserHandler } from "../../hooks/use-validate-user";
import { getConfig } from "../../models/voucher-distribution";
import { useCartState } from "../../store/use-cart-state";
import { useUserState } from "../../store/use-user-state";
import { useVouchersDistributionState } from "../../store/use-vouchers-distribution-state";
import { configName } from "../config/config-name";
import { routes } from "../config/routes";

export const ValidateUser = () => {
  const { t } = useTranslation();
  const flowPath = useFlowPath();
  const { user } = useUserState();
  const { setProductsLimit } = useCartState();
  const { voucherDistribution } = useVouchersDistributionState();
  const config = getConfig(voucherDistribution, configName);
  const rulesAcceptanceRequired = voucherDistribution?.rulesAcceptanceRequired ?? false;

  const postAuthRoute = rulesAcceptanceRequired ? routes.termsAgreement.raw() : routes.catalog.raw();
  const { handleSubmitUseIdForm, isLoading } = useValidateUserHandler({
    configName,
    redirectRoute: flowPath(
      config?.authorizationMethod === "external_uid_authorization" ? postAuthRoute : routes.codeValidation.raw(),
    ),
  });

  return (
    <IntersectionFadeIn className="-mt-24 flex h-auto w-full flex-1 items-center justify-center max-lg:p-4">
      <div className="mx-auto flex max-w-lg flex-col rounded-2xl bg-card px-4 py-6 md:p-8 lg:p-12">
        <h3 className="font-serif text-2xl text-card-foreground lg:text-3xl">
          {t(`cmsTranslations.friends_and_family.user_id_form.title`)}
        </h3>
        <p className="mt-1.5 text-base text-muted-foreground">
          {t(`cmsTranslations.friends_and_family.user_id_form.description`)}
        </p>
        <div className="mt-8">
          <UserIdForm
            onSubmit={handleSubmitUseIdForm}
            apiError={user?.error}
            isLoading={isLoading}
            authorizationMethod={config?.authorizationMethod}
          />
        </div>
      </div>
    </IntersectionFadeIn>
  );
};
